module.exports = __webpack_public_path__ + "img/annai_regi_sp.224f072a.gif";